import { useEffect, useState } from "react";
import { api, resolveImage } from "@/lib/api";
import { Trash2, FileText, Download, Mail, Phone } from "lucide-react";
import { toast } from "sonner";

export default function AdminApplications() {
    const [items, setItems] = useState([]);
    const load = () => api.get("/admin/applications").then((r) => setItems(r.data));
    useEffect(() => { load(); }, []);

    const del = async (it) => {
        if (!confirm("Bewerbung wirklich löschen? (Datei wird entfernt)")) return;
        await api.delete(`/admin/applications/${it.id}`);
        toast.success("Gelöscht");
        load();
    };

    return (
        <div className="p-6 md:p-10 max-w-6xl">
            <div className="text-[11px] font-bold uppercase tracking-widest text-brand-green">Karriere</div>
            <h1 className="mt-1 font-display text-3xl font-bold">Bewerbungen</h1>

            <div className="mt-6 grid gap-4">
                {items.map((it) => (
                    <div key={it.id} className="card-clean p-5" data-testid={`app-row-${it.id}`}>
                        <div className="flex items-start justify-between gap-4 flex-wrap">
                            <div>
                                <div className="font-display text-lg font-semibold">{it.name}</div>
                                <div className="mt-1 text-sm text-brand-charcoal/70 flex items-center flex-wrap gap-x-4 gap-y-1">
                                    <span className="inline-flex items-center gap-1.5"><Mail className="h-3.5 w-3.5" /> {it.email}</span>
                                    {it.phone && <span className="inline-flex items-center gap-1.5"><Phone className="h-3.5 w-3.5" /> {it.phone}</span>}
                                </div>
                                <div className="mt-2 inline-flex items-center gap-2 rounded-full bg-brand-cream-dark/60 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-widest text-brand-green">
                                    {it.position || "Allgemein"}
                                </div>
                                {it.message && <p className="mt-3 text-sm text-brand-charcoal/75 whitespace-pre-line">{it.message}</p>}
                            </div>
                            <div className="flex flex-col items-end gap-2">
                                <div className="text-xs text-brand-charcoal/50">{new Date(it.created_at).toLocaleString()}</div>
                                {it.cv?.url && (
                                    <a href={resolveImage(it.cv.url)} target="_blank" rel="noreferrer noopener" className="btn-outline-dark text-xs py-2">
                                        <Download className="h-3.5 w-3.5" /> CV ({Math.round((it.cv.size || 0) / 1024)} KB)
                                    </a>
                                )}
                                <button onClick={() => del(it)} className="text-xs text-brand-red font-semibold inline-flex items-center gap-1.5" data-testid={`app-delete-${it.id}`}><Trash2 className="h-3.5 w-3.5" /> Löschen</button>
                            </div>
                        </div>
                    </div>
                ))}
                {items.length === 0 && <div className="card-clean p-10 text-center text-sm text-brand-charcoal/60"><FileText className="h-8 w-8 mx-auto text-brand-charcoal/30 mb-2" />Noch keine Bewerbungen.</div>}
            </div>
        </div>
    );
}
